import { render, staticRenderFns } from "./CaseManagementCard.vue?vue&type=template&id=69cc9025&scoped=true"
import script from "./CaseManagementCard.vue?vue&type=script&lang=ts"
export * from "./CaseManagementCard.vue?vue&type=script&lang=ts"
import style0 from "./CaseManagementCard.vue?vue&type=style&index=0&id=69cc9025&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc9025",
  null
  
)

export default component.exports